<template>
  <div
    :class="
      `container course-overview bg-white ${
        $store.state.app.isMobile ? 'pd-0-f' : 'pd-25-f'
      }`
    "
  >
    <!-- <vue-custom-scrollbar :style="`height: ${getScrollHeight()}`"> -->
    <div v-if="$store.state.app.activeGroup.learnConfig.course.showAlert">
      <div v-for="(alert, i) in obj.alerts" :key="i + '_alert'">
        <template v-if="alert.hasLink">
          <router-link
            v-if="
              (alert.type == 503 && obj.percent == 100) || alert.type != 503
            "
            :to="alert.rawLink"
          >
            <div
              :class="`alert alert-${alert.color} d-flex align-items-center`"
              role="alert"
            >
              <feather
                :type="alert.featherIcon"
                class="mg-r-10"
                style="min-width: 16px"
              ></feather>
              <div>
                {{ alert.msg }}
              </div>
              <div class="mg-l-auto">
                <button :class="`btn btn-outline-${alert.color} btn-xs d-flex`">
                  үзэх<feather
                    type="arrow-right"
                    class="mg-l-5"
                    size="14"
                  ></feather>
                </button>
              </div>
            </div>
          </router-link>
        </template>
        <template v-else>
          <div
            :class="`alert alert-${alert.color} d-flex align-items-center`"
            role="alert"
          >
            <feather :type="alert.featherIcon" class="mg-r-10"></feather>
            {{ alert.msg }}
          </div>
        </template>
      </div>
    </div>
    <!-- <div v-html="obj.info" class="tx-13 tx-color-02" ></div> -->
    <video
      :loop="true"
      :muted="true"
      v-if="obj.videoCover != ''"
      controls
      controlslist="nodownload"
      autoplay
      class="mx-wd-100p"
    >
      <source :src="obj.videoCover" type="video/mp4" />
    </video>
    <img v-else :src="`${obj.cover}?w=1200`" class="mx-wd-100p" />
    <ul
      v-if="!$store.state.app.isMobile"
      class="nav nav-justified nav-line mg-t-10 mg-b-20"
    >
      <li class="nav-item">
        <a
          @click="changeTab(1)"
          class="nav-link"
          role="button"
          :class="{ active: activeTab == 1 }"
          >Тухай</a
        >
      </li>
      <li class="nav-item">
        <a
          @click="changeTab(2)"
          class="nav-link pos-relative"
          role="button"
          :class="{ active: activeTab == 2 }"
          >Шалгалт
          <div
            v-if="
              obj.boxes.filter(x => x.ot == 116 && x.forms.length).length > 0 ||
                obj.lessonExamCount > 0
            "
            class="pos-absolute t-5 r-10 badge badge-primary"
          >
            {{
              obj.boxes.filter(x => x.ot == 116 && x.forms.length).length > 0
                ? obj.boxes.filter(x => x.ot == 116 && x.forms.length)[0].forms
                    .length + obj.lessonExamCount
                : obj.lessonExamCount
            }}
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a
          @click="changeTab(3)"
          class="nav-link pos-relative"
          role="button"
          :class="{ active: activeTab == 3 }"
          >Хэлэлцүүлэг
          <div
            v-if="
              obj.boxes.filter(x => x.ot == 124 && x.tasks.length).length > 0
            "
            class="pos-absolute t-5 r-10 badge badge-primary"
          >
            {{
              obj.boxes.filter(x => x.ot == 124 && x.tasks.length)[0].tasks
                .length
            }}
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a
          @click="changeTab(4)"
          class="nav-link pos-relative"
          role="button"
          :class="{ active: activeTab == 4 }"
          >Лайв сургалт
          <div
            v-if="hasActiveZoom()"
            class="pos-absolute t-5 r--35 bd bd-1 bd-danger rounded tx-11 tx-rubik pd-x-5-f pd-y-1-f mg-t-5 tx-danger"
          >
            <feather type="wifi" class="ht-10-f wd-10-f tx-danger"></feather>
            LIVE
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a
          @click="changeTab(5)"
          class="nav-link pos-relative"
          role="button"
          :class="{ active: activeTab == 5 }"
          >Бие даалт
          <div
            v-if="
              obj.boxes.filter(x => x.ot == 502 && x.tasks.length).length > 0 ||
                obj.lessonWorkTestCount > 0
            "
            class="pos-absolute t-5 r-10 badge badge-primary"
          >
            {{
              obj.boxes.filter(x => x.ot == 502).length > 0
                ? obj.boxes.filter(x => x.ot == 502).length +
                  obj.lessonWorkTestCount
                : obj.lessonWorkTestCount
            }}
          </div>
        </a>
      </li>
    </ul>
    <div v-else class="divider-text">Сургалтын агуулга</div>
    <div :style="{ 'min-height': $store.state.app.isMobile ? '0' : '600px' }">
      <div
        v-show="activeTab == 1"
        :style="{ padding: $store.state.app.isMobile ? '0px 10px' : 'inherit' }"
      >
        <div class="d-flex mg-b-20">
          <div class="">
            <h6 class="tx-13 tx-inverse tx-semibold mg-b-5">
              Төрөл: <span class="tx-rubik">{{ obj.locType.name }}</span>
            </h6>
            <div class="text-muted tx-12">
              Үргэлжлэх хугацаа: {{ obj.date.start | moment("YYYY.MM.DD") }} -
              {{ obj.date.end | moment("YYYY.MM.DD") }}
            </div>
          </div>
          <div
            v-if="!$store.state.app.isMobile"
            class="mg-l-auto btn-group"
            role="group"
            aria-label="Basic example"
          >
            <button
              @click="showCourseSurvey(389)"
              v-if="
                obj.boxes.filter(x => x.ot == 389 && x.forms.length).length > 0
              "
              type="button"
              class="btn btn-outline-primary"
            >
              <feather
                type="check-circle"
                class="wd-15-f ht-15-f mg-r-5"
              ></feather>
              Энд дарж судалгаа бөглөнө үү
            </button>
            <button
              @click="showCourseSurvey(503)"
              v-if="
                obj.boxes.filter(x => x.ot == 503 && x.forms.length).length > 0
              "
              type="button"
              class="btn btn-outline-primary"
            >
              <feather type="star" class="wd-15-f ht-15-f mg-r-5"></feather>
              Энд дарж үнэлгээ өгнө үү
            </button>
          </div>
        </div>

        <div v-html="obj.info" class="tx-13 tx-color-02 gosm-edtr-outer"></div>
      </div>
      <div v-if="activeTab == 2" class="tx-13 tx-color-02">
        <template
          v-if="obj.boxes.filter(x => x.ot == 116 && x.forms.length).length > 0"
        >
          <form-list
            v-for="(b, i) in obj.boxes.filter(
              x => x.ot == 116 && x.forms.length
            )"
            :forms="b.forms"
            :box="b"
            :course="obj"
            :key="i"
            @on-show-exam-result="$emit('on-show-exam-result', $event)"
            backTo="course"
          />
        </template>
        <template v-else>
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            <strong>Одоогоор шалгалт зарлагдаагүй байна.</strong>
          </div>
        </template>

        <template v-if="obj.hasLessonExam">
          <div class="divider-text">Явцын шалгалт</div>
          <div
            v-for="(lb, lbi) in obj.boxes.filter(
              x => x.ot == 114 && x.tasks.length
            )"
            :key="lbi"
          >
            <div v-for="(l, li) in lb.tasks" :key="li">
              <form-list
                v-for="(b, ibi) in l.boxes.filter(
                  x => x.ot == 416 && x.forms.length
                )"
                :forms="b.forms.filter(x => x.flag == 500)"
                :box="{ nm: 'Хичээл: ' + l.task, id: b.id, ot: b.ot }"
                :lid="l.id"
                :course="obj"
                backTo="courseHome"
                :key="ibi"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            <strong>Одоогоор хичээлийн шалгалт зарлагдаагүй байна.</strong>
          </div>
        </template>
      </div>
      <div v-show="activeTab == 3" class="tx-13 tx-color-02">
        <template
          v-if="obj.boxes.filter(x => x.ot == 124 && x.tasks.length).length > 0"
        >
          <forum-list
            v-for="(b, i) in obj.boxes.filter(
              x => x.ot == 124 && x.tasks.length
            )"
            :tasks="b.tasks"
            :box="b"
            :b="b"
            :key="i"
            @on-detail="$emit('on-detail', { event: $event, box: b })"
          />
        </template>
        <template v-else>
          <div class="container d-flex justify-content-center ht-100p">
            <div
              class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
            >
              <div class="wd-80p wd-sm-300 mg-b-15">
                <img src="assets/svg/boxempty.svg" alt="" class="img-fluid" />
              </div>
              <h4 class="tx-20 tx-sm-24 text-muted">
                Хэлэлцүүлэг эхлээгүй байна
              </h4>
            </div>
          </div>
        </template>
      </div>
      <div v-show="activeTab == 4" class="tx-13 tx-color-02">
        <!-- {{obj.boxes}} -->
        <template
          v-if="
            obj.boxes.filter(
              x => (x.ot == 493 || x.ot == 500 || x.ot == 516) && x.tasks.length
            ).length > 0
          "
        >
          <zoom-list
            v-for="(b, i) in obj.boxes.filter(
              x => (x.ot == 493 || x.ot == 500 || x.ot == 516) && x.tasks.length
            )"
            :tasks="b.tasks"
            :course="obj"
            :box="b"
            :b="b"
            :key="i"
            backTo="course"
            @on-detail="$emit('on-detail', { event: $event, box: b })"
          />
        </template>
        <template v-else>
          <div class="container d-flex justify-content-center ht-100p">
            <div
              class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
            >
              <div class="wd-80p wd-sm-300 mg-b-15">
                <img src="assets/svg/boxempty.svg" alt="" class="img-fluid" />
              </div>
              <h4 class="tx-20 tx-sm-24 text-muted">
                Онлайн сургалт зарлагдаагүй байна
              </h4>
            </div>
          </div>
        </template>
      </div>
      <div v-if="activeTab == 5" class="tx-13 tx-color-02">
        <template v-if="obj.boxes.filter(x => x.ot == 502).length > 0">
          <assign-list
            v-for="(b, i) in obj.boxes.filter(x => x.ot == 502)"
            :course="obj"
            :b="b"
            :key="i"
            backTo="course"
            @on-detail="$emit('on-detail', { event: $event, box: b })"
            @show-attach="$emit('show-attach', $event)"
          />
        </template>
        <template v-else>
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            <strong>Бие даалт байхгүй байна !</strong>
          </div>
        </template>

        <template v-if="obj.hasLessonWorkTest">
          <div class="divider-text">Дасгал ажил</div>
          <div
            v-for="(lb, lbi) in obj.boxes.filter(
              x => x.ot == 114 && x.tasks.length
            )"
            :key="lbi"
          >
            <div v-for="(l, li) in lb.tasks" :key="li">
              <form-list
                v-for="(b, ibi) in l.boxes.filter(
                  x => x.ot == 117 && x.forms.length
                )"
                :forms="b.forms.filter(x => x.flag == 800)"
                :box="{ nm: 'Хичээл: ' + l.task, id: b.id, ot: b.ot }"
                :lid="l.id"
                :course="obj"
                backTo="courseHome"
                :key="ibi"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            <strong>Одоогоор дасгал ажил үүсгээгүй байна.</strong>
          </div>
        </template>
      </div>
    </div>

    <!-- <div class="mg-b-40" v-for="(b,i) in obj.boxes" :key="i+'_boxes'">
        <h4 v-if="(b.tasks.length || b.ot==502) || b.attaches.length || b.forms.length" class="mg-b-15 mg-lg-b-10 tx-color-02 bd-b bd-5 pd-b-5">{{b.nm}}</h4>
        <div v-if="b.tasks.length">
          <teacher-list
            v-if="b.ot==396"
            :tasks="obj.teachers"
            @on-detail="$emit('on-detail',  {event: $event, box: b})"
          />
          <lesson-list
            v-else-if="b.ot==114"
            :tasks="b.tasks"
            @on-detail="$emit('on-detail', $event)"
          />
          <forum-list
            v-else-if="b.ot==124"
            :tasks="b.tasks"
            @on-detail="$emit('on-detail', {event: $event, box: b})"
          />

          <zoom-list
            v-else-if="b.ot==500"
            :tasks="b.tasks" :course="obj"
            @on-detail="$emit('on-detail', {event: $event, box: b})"
          />
        </div>
        <assign-list v-if="b.ot==502"
            :tasks="b.tasks" :box="b" :parentTask="obj" :course="obj"
            @on-detail="$emit('on-detail', {event: $event, box: b})" @show-attach="$emit('show-attach', $event)"
            @on-reload="$emit('on-reload')"
          />

        <div v-if="b.forms.length">
          <form-list
            v-if="b.ot==116 || b.ot==389 || b.ot==503"
            :forms="b.forms"
            :box="b"
            @on-show-exam-result="$emit('on-show-exam-result', $event)"
            backTo="course"
          />
        </div>
        <div v-if="b.attaches.length">
          <div class v-for="(a,i) in b.attaches" :key="i+'_attaches'">{{a}}</div>
        </div>
      </div> -->
    <!-- </vue-custom-scrollbar> -->

    <b-modal v-model="modal.show" hide-header hide-footer centered size="lg">
      <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
        <a
          @click="modal.show = false"
          role="button"
          class="close pos-absolute t-15 r-15"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </a>
        <div class="media align-items-center">
          <span class="tx-color-03 d-none d-sm-block">
            <feather type="pen-tool" class="wd-40-f ht-40-f"></feather>
          </span>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">
              {{ modal.ot == 389 ? "Судалгаа" : "Үнэлгээ" }}
            </h4>
            <p class="tx-13 tx-color-03 mg-b-0">
              {{
                modal.ot == 389
                  ? "Судалгаанд идэвхтэй хамрагдана уу. Баярлалаа"
                  : "Сургалтад үнэлгээ өгнө үү баярлалаа"
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30 ht-400">
        <template
          v-if="
            obj.boxes.filter(x => x.ot == modal.ot && x.forms.length).length > 0
          "
        >
          <form-list
            v-for="(b, i) in obj.boxes.filter(
              x => x.ot == modal.ot && x.forms.length
            )"
            :forms="b.forms"
            :box="b"
            :key="i"
            @on-show-exam-result="$emit('on-show-exam-result', $event)"
            backTo="course"
          />
        </template>
        <template v-else>
          <div class="container d-flex justify-content-center ht-100p">
            <div
              class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
            >
              <div class="wd-80p wd-sm-300 mg-b-15">
                <img src="assets/svg/boxempty.svg" alt="" class="img-fluid" />
              </div>
              <h4 class="tx-20 tx-sm-24 text-muted">Мэдээлэл хоосон байна</h4>
            </div>
          </div>
        </template>
      </div>
      <div class="modal-footer pd-x-20 pd-y-15"></div>
    </b-modal>
  </div>
</template>

<script>
import TeacherDetail from "./teacherDetail.vue";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
// import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    TeacherDetail, // vueCustomScrollbar,
    assignList: () => ({
      component: import("@/views/modules/lms/student/sections/assignList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    // teacherList: () => ({
    //   component: import("@/views/modules/lms/student/sections/teacherList.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    // lessonList: () => ({
    //   component: import("@/views/modules/lms/student/sections/lessonList.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    zoomList: () => ({
      component: import("@/views/modules/lms/student/sections/zoomList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formList: () => ({
      component: import("@/views/modules/lms/student/sections/formList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    forumList: () => ({
      component: import("@/views/modules/lms/student/sections/forumList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    obj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      activeTab: 1,
      modal: {
        ot: null,
        show: false
      }
    };
  },
  mounted() {
    //console.log('mounted', this.obj.boxes.filter(x=>x.ot==114));
  },
  methods: {
    changeTab(m) {
      this.activeTab = m;
    },
    getScrollHeight() {
      let mh = 170;
      if (screen.width <= 1024) {
        mh = 80;
      }
      return `calc(${window.innerHeight}px - ${mh}px);`;
    },
    showCourseSurvey(ot) {
      this.modal.ot = ot;
      this.modal.show = true;
    },
    hasActiveZoom() {
      //console.log(this.obj.boxes.filter((x) => (x.ot == 493 || x.ot == 500 || x.ot == 516) && x.tasks.length));
      this.obj.boxes
        .filter(
          x => (x.ot == 493 || x.ot == 500 || x.ot == 516) && x.tasks.length
        )
        .forEach(bx => {
          bx.tasks.forEach(t => {
            //if(t['dueStartDate']<=this.obj.date.now)
            //console.log(t.dueStartDate, this.obj.date.now)
          });
        });

      let activezooms = this.obj.boxes.filter(
        x =>
          (x.ot == 493 || x.ot == 500 || x.ot == 516) &&
          x.tasks.length &&
          x.tasks.filter(
            t =>
              t["dueStartDate"] <= this.obj.date.now &&
              t["dueDate"] > this.obj.date.now
          ).length
      );
      if (activezooms.length) {
        return true;
      } else return false;

      // let rv = "";
      // if (this.t["dueStartDate"] > this.nowDate) {
      //   rv = `<span class="badge badge-secondary">Хурал эхлэх | ${moment(
      //     this.t["dueStartDate"]
      //   ).format("MM-сар DD-н HHц:mmм")}</span>`;
      // } else {-
      //   if (this.t["dueDate"] > this.nowDate) {
      //     rv = '<span class="badge badge-warning">Хурал үргэлжилж байна</span>';
      //   } else {
      //     rv = `<span class="badge badge-success">Дууссан | ${moment(
      //       this.t["dueDate"]
      //     ).format("MM-сар DD-н HHц:mmм")}</span>`;
      //   }
      // }
      // return rv;
    }
  }
};
</script>

<style></style>
